import { Card, CardHeader, CardTitle, CardSubtitle } from '@/components/ui/Card';

const LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] as const;

export function DayOfWeekChart({
    counts,
    windowLabel = 'last 30 days',
}: {
    counts: number[];
    windowLabel?: string;
}) {
    const safe = Array.isArray(counts) && counts.length === 7 ? counts : [0, 0, 0, 0, 0, 0, 0];
    const max = Math.max(1, ...safe);
    const total = safe.reduce((a, b) => a + b, 0);

    return (
        <Card>
            <CardHeader>
                <div className="flex flex-col gap-0.5">
                    <CardTitle>Sessions by day of week</CardTitle>
                    <CardSubtitle>{windowLabel}</CardSubtitle>
                </div>
                <span className="text-xs text-text-subtle tabular-nums">{total} total</span>
            </CardHeader>
            {total === 0 ? (
                <p className="text-sm text-text-subtle py-4 text-center">No sessions in this window.</p>
            ) : (
                <ul className="flex flex-col gap-1.5">
                    {safe.map((n, i) => {
                        const pct = (n / max) * 100;
                        return (
                            <li key={LABELS[i]} className="flex items-center gap-2 text-xs">
                                <span className="w-8 shrink-0 text-text-subtle">{LABELS[i]}</span>
                                <div className="flex-1 h-2 bg-surface-muted rounded-full overflow-hidden">
                                    <div
                                        className="h-full bg-accent rounded-full"
                                        style={{ width: `${pct}%` }}
                                        role="progressbar"
                                        aria-valuenow={n}
                                        aria-valuemin={0}
                                        aria-valuemax={max}
                                        aria-label={`${LABELS[i]}: ${n} sessions`}
                                    />
                                </div>
                                <span className="w-8 shrink-0 text-right tabular-nums text-text">{n}</span>
                            </li>
                        );
                    })}
                </ul>
            )}
        </Card>
    );
}
